import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module';
import { act } from './act.module';
import { message } from './message.module';
import { simcardList } from './simcardList.module';
import { tagList } from './tagList.module';
import { passwordManager } from './passwordManager.module';

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        act,
        auth,
        message,
        tagList,
        simcardList,
        passwordManager,
    },

    actions: {
        resetStore({ commit }) {
            //ref: https://stackoverflow.com/questions/66139527/how-to-get-all-registered-vuex-modules
            const modules = this._modules.root._children;

            for (let moduleName in modules) {
                commit(`${moduleName}/resetState`);
            }
        }
    }
})